import React from 'react';
import InitiativesSection from './InitiativesSection.jsx';

const EmployeeInitiatives = ({ employee }) => {
  // exclude draft copies
  const initiativeParticipationsFiltered = (arr) =>
    arr.filter(
      (initiativeParticipations) => !initiativeParticipations.initiative.draft
    );
  const {
    communicationParticipations,
    readinessParticipations,
    trainingParticipations,
    sustainmentParticipations,
  } = employee;
  return (
    <div>
      <InitiativesSection
        initiativeParticipations={initiativeParticipationsFiltered(
          communicationParticipations
        )}
        type="communication"
      />
      <InitiativesSection
        initiativeParticipations={initiativeParticipationsFiltered(
          readinessParticipations
        )}
        type="readiness"
      />
      <InitiativesSection
        initiativeParticipations={initiativeParticipationsFiltered(
          trainingParticipations
        )}
        type="training"
      />
      <InitiativesSection
        initiativeParticipations={initiativeParticipationsFiltered(
          sustainmentParticipations
        )}
        type="sustainment"
      />
    </div>
  );
};

export default EmployeeInitiatives;
